import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { User } from '../_models/user.model';
import { Permission } from '../_models/permission.model';
import { Role } from '../_models/role.model';
import { Profiles } from '../_models/profile.model'
import {catchError, map, tap} from 'rxjs/operators';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import {BASE_URL,API_PERMISSION_URL,API_ROLES_URL,API_USERS_URL} from '../../connection.data';
import { AuthUtils } from '../util/auth.util';
//const API_USERS_URL = 'api/users';
//const API_PERMISSION_URL = 'api/permissions';
//const API_ROLES_URL = 'api/roles';

//const BASE_URL = "http://localhost:3000"                //INTERNAL DEV
//const BASE_URL = "http://ir4hub.cl:45016"                //LAB DEV

@Injectable()
export class AuthService {
    constructor(private http: HttpClient) {
        this.rememberLastLogin();
    }
    // Authentication/Authorization
    /*login(email: string, password: string): Observable<User> {
        return this.http.post<User>(API_USERS_URL, { email, password });
    }*/
    login(email: string, password: string): Observable<{user:User, token:string, plant_name: string, plant_id: number}> {
        const url = `${API_USERS_URL}/login`;
        return this.http.post<{user: User, token:string}>(url, { email, password }).pipe(
            map((rsp)=>{
                if(rsp["status"]=="success"){
                    let user:User = new User();
                    const data = rsp["rows"][0];
                    user.id = data.uid;
                    user.active = data.active;
                    user.login = data.login;
                    user.refreshToken = data.token;
                    user.group_id = data.res_group;
                    user.group_name = data.group_name;
                    user.username = data.partner_name;
                    user.partner_id = data.partner_id;
                    user.fullname = user.username;
                    user.company_id = data.company_id;
                    user.company_name = data.company_name;
                    user['company_theme_name'] = data.company_theme_name;
                    user['icon_file'] = data.icon_file;
                    user['icon_filename'] = data.icon_filename;
                    return {user:user, token:rsp["token"], plant_name: rsp["plant_name"], plant_id: rsp["plant_id"]};
                }
                return null;
            })
        );
    }

    getUID(){
        return parseInt(localStorage.getItem(environment.uid));
    }

    // getToken(){
    //     return localStorage.getItem(environment.authTokenKey);
    // }

    getUserByToken(): Observable<User> {
        const userToken = localStorage.getItem(environment.authTokenKey);
        const httpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + userToken);
        return this.http.get<User>(`${API_USERS_URL}/token-login`, { headers: httpHeaders }).pipe(
					// tap(resp=>console.log("get user by token resp: ", resp)),
            map((rsp)=>{
                if(rsp["status"]=="success"){
                    let user:User = new User();
                    const data = rsp["rows"][0];
                    user.id = data.uid;
                    user.active = data.active;
                    user.login = data.login;
                    user.refreshToken = data.token;
                    user.group_id = data.res_group;
                    user.group_name = data.group_name;
                    user.username = data.partner_name;
                    user.partner_id = data.partner_id;
                    user.fullname = user.username;
                    user.company_id = data.company_id;
                    user.company_name = data.company_name;
                    user['company_theme_name'] = data.company_theme_name;
                    user['icon_file'] = data.icon_file;
                    user['icon_filename'] = data.icon_filename;
                    return user;
                }
                return null;
            })
        );
    }

    register(user: User): Observable<any> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<User>(API_USERS_URL, user, { headers: httpHeaders })
            .pipe(
                map((res: User) => {
                    return res;
                }),
                catchError(err => {
                    return null;
                })
            );
    }

    /*
     * Submit forgot password request
     *
     * @param {string} email
     * @returns {Observable<any>}
     */
    public requestPassword(email: string): Observable<any> {
    	return this.http.get(API_USERS_URL + '/forgot?=' + email)
    		.pipe(catchError(this.handleError('forgot-password', []))
	    );
    }


    /*getAllUsers(): Observable<User[]> {
		return this.http.get<User[]>(API_USERS_URL);
    }*/
    getAllUsers(): Observable<User[]> {
        const url = `${API_USERS_URL}/findUsers`;
        return this.http.get<User[]>(url);
    }
    getUsers(): Observable<any[]> {
        const url = `${API_USERS_URL}/users`;
        return this.http.get<any>(url);
    }

    getUserById(userId: number): Observable<User> {
        const url = `${API_USERS_URL}/users/${userId}`;
		return this.http.get<User>(url);
    }
    toggleUsers(login: string): Observable<any> {
        const url = `${API_USERS_URL}/toggleUsers?login=${login}`;
		return this.http.get<any>(url);
	}
    // DELETE => delete the user from the server
	deleteUser(userId: number) {
        const url = `${API_USERS_URL}/${userId}`;
        return this.http.delete(url);

    }

    // UPDATE => PUT: update the user on the server
	updateUser(_user: User): Observable<any> {
        const url = `${API_USERS_URL}`;
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		return this.http.put(url, _user, { headers: httpHeaders });
	}

    // CREATE =>  POST: add a new user to the server
	createUser(user: User): Observable<User> {
        const url = `${API_USERS_URL}`;
    	const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        console.log(url);
		return this.http.post<User>(url, user, { headers: httpHeaders});
    }


    // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	findUsers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        const url = `${API_USERS_URL}/findUsers`;
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		return this.http.post<QueryResultsModel>(url, queryParams, { headers: httpHeaders});
    }
    updateStatusForUser(user: User, status: boolean): Observable<any> {
		const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		/*const body = {
			userForUpdate: users,
			status: Boolean
        };*/
        const url = `${API_USERS_URL}/userStatusUpdate`;
		//const url = API_PRODUCTS_URL + '/updateStatus';
		return this.http.put(url, user, { headers: httpHeaders });
	}

    // Permission
    getAllPermissions(): Observable<Permission[]> {
		return this.http.get<Permission[]>(API_PERMISSION_URL);
    }



    getRolePermissions(roleId: number): Observable<Permission[]> {
        return this.http.get<Permission[]>(API_PERMISSION_URL + '/getRolePermission?=' + roleId);
    }

    // Roles
    getAllRoles(): Observable<Role[]> {
        return this.http.get<Role[]>(API_ROLES_URL);
    }
    getAllProfiles():Observable<Profiles[]> {
        const url = `${API_USERS_URL}/getAllProfiles`;
        return this.http.get<Profiles[]>(url);
    }

    getRoleById(roleId: number): Observable<Role> {
		return this.http.get<Role>(API_ROLES_URL + `/${roleId}`);
    }
    getProfileById(profileId:number):Observable<Profiles[]> {
        const url = `${API_USERS_URL}/getProfileById`;
        return this.http.get<Profiles[]>(url+ `/${profileId}`);
    }

    // CREATE =>  POST: add a new role to the server
	createRole(role: Role): Observable<Role> {
		// Note: Add headers if needed (tokens/bearer)
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.post<Role>(API_ROLES_URL, role, { headers: httpHeaders});
	}

    // UPDATE => PUT: update the role on the server
	updateRole(role: Role): Observable<any> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.put(API_ROLES_URL, role, { headers: httpHeaders });
    }

    // UPDATE => PUT: update the role on the server
	updateProfile(profile: Profiles): Observable<any> {
        const url = `${API_USERS_URL}/updateProfile`;
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.put(url, profile, { headers: httpHeaders });
    }

	// DELETE => delete the role from the server
	deleteRole(roleId: number): Observable<Role> {
		const url = `${API_ROLES_URL}/${roleId}`;
		return this.http.delete<Role>(url);
	}

    // Check Role Before deletion
    isRoleAssignedToUsers(roleId: number): Observable<boolean> {
        return this.http.get<boolean>(API_ROLES_URL + '/checkIsRollAssignedToUser?roleId=' + roleId);
    }

    findRoles(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        // This code imitates server calls
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.post<QueryResultsModel>(API_ROLES_URL + '/findRoles', queryParams, { headers: httpHeaders});
    }
    findProfiles(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.post<QueryResultsModel>(API_USERS_URL + '/findProfiles', queryParams, { headers: httpHeaders});
    }

 	/*
 	 * Handle Http operation that failed.
 	 * Let the app continue.
     *
	 * @param operation - name of the operation that failed
 	 * @param result - optional value to return as the observable result
 	 */
    private handleError<T>(operation = 'operation', result?: any) {
        return (error: any): Observable<any> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }

    // baseUrl:string = '';
    private user: any;
    private plant: any;
    private token: any;
    authenticated$ = new BehaviorSubject(false);
    signout$ = new Subject();
    // mapMode: string = 'satellite';
    // private lastLoginDate: Date;
    // private LOGIN_TIMEOUT_MS = 60*60*1000;

    // constructor(){
    //     // this.baseUrl = API_USERS_URL;
    //     this.rememberLastLogin();
    //     console.log("constructor auth service")
    // }

    rememberLastLogin(){
        // console.log("remember last login")
        if(this.isAuthenticated()) return;
        // const doesRemember = Boolean(localStorage.getItem(environment.rememberLastLogin));
        // if(doesRemember){
            const userStr = localStorage.getItem(environment.user);
            //console.log(userStr);
            if(userStr!=null && userStr!='undefined') this.setUser(JSON.parse(userStr));
            // const lastLoginDateStr = Number(localStorage.getItem(environment.lastLoginDate));
            // if(!isNaN(lastLoginDateStr)) this.lastLoginDate = new Date(Number(lastLoginDateStr));
            const token = localStorage.getItem(environment.token);

            if(token!=null) this.setToken(token);

            if(!this.isAuthenticated()){
                this.signOut();
            }else{
                // console.log(`last map mode: ${localStorage.getItem(environment.mapMode)}`);
                // this.mapMode = localStorage.getItem(environment.mapMode) || 'satellite';
                // console.log(`new map mode: ${this.mapMode}`)
                this.authenticated$.next(this.user);
                const plant = localStorage.getItem(environment.plant);
                if(plant) this.setPlant(JSON.parse(plant));
            }
        // }
    }

    //Se ha marcado "recuerdame" y por tanto recuerda el nombre de usuario para formulario
    doesRememberLogin(){
        const doesRemember = Boolean(localStorage.getItem(environment.rememberLastLogin));
        return doesRemember;
    }

    rememberLastUserLogin(){
        return localStorage.getItem(environment.login);
    }

    //Recuerda el ultimo usuario logueado por tanto es posible saltarse el login
    doesRemember(){
        const userStr = localStorage.getItem(environment.user);
        // console.log(userStr);
        if(userStr==null || userStr=="") return false;
        // const lastLoginDateStr = Number(localStorage.getItem(environment.lastLoginDate));
        // if(!isNaN(lastLoginDateStr)) this.lastLoginDate = new Date(Number(lastLoginDateStr));
        const token = localStorage.getItem(environment.token);
        // console.log(token);
        if(token==null || token=="")return false;

        if(AuthUtils.isTokenExpired(token)) return false;
        return true;
    }

    markForRemember(){
        localStorage.setItem(environment.rememberLastLogin, `${true}`);
        localStorage.setItem(environment.login, this.user.login);
    }

    markForNotRemember(){
        localStorage.setItem(environment.rememberLastLogin, `${false}`);
    }

    // login(user: any){
    //     // console.log("login")
    //     // console.log(user)
    //     return this.userService.login(user).pipe(
    //         tap((response: any)=>{
    //             // console.log("login response: ");console.dir(response);
    //             if(response.status && response.status=='success'){
    //                 this.setUser(response.user);
    //                 this.setToken(response.token);
    //                 this.authenticated$.next(response.user);
    //                 // console.log("login: is authenticated now ?");console.log(this.isAuthenticated());
    //                 // this.setLastLoginDate(new Date())
    //             }
    //         })
    //     )
    // }

    // setLastLoginDate(date){
        // this.lastLoginDate = date;
        // localStorage.setItem(environment.lastLoginDate, `${date.getTime()}`);
    // }

    setUser(user: any){
        // console.log("set user to");console.dir(user);
        this.user = user;
        localStorage.setItem(environment.user, JSON.stringify(user));
    }

    setPlant(plant: any){
        // console.log("set plant to");console.dir(plant);
        this.plant = plant;
        localStorage.setItem(environment.plant, JSON.stringify(plant));
    }

    setToken(token: string){
        // console.log("set token to");console.dir(token);
        this.token = token;
        localStorage.setItem(environment.token, token);
    }

    getToken(){
        return this.token;
    }

    getUser(){
        return this.user;
    }

    getPlant(){
        return this.plant;
    }

    signOut(){
        // console.log("signout");
        this.token = null;
        this.user = null;
        localStorage.removeItem(environment.token);
        localStorage.removeItem(environment.user);
        this.signout$.next(true);
    }

    isAuthenticated(){
        // const now = new Date();
        // console.log(this.user!=null && this.token!=null && this.lastLoginDate != null)
        // if(this.user!=null && this.token!=null && this.lastLoginDate != null){
        //     console.log(`now: ${now.toLocaleString('sv')}`)
        //     console.log(`login time: ${this.lastLoginDate.toLocaleString('sv')}`)
        //     console.log(`substraction: ${now.getTime() - this.lastLoginDate.getTime()} < ${this.LOGIN_TIMEOUT_MS}`)
        //     console.log((now.getTime() - this.lastLoginDate.getTime() > this.LOGIN_TIMEOUT_MS))
        // }
        /*console.log("is authenticated?");
        console.log("user: ");console.dir(this.user);
        console.log("token: ");console.dir(this.token);
        console.log("is token expired?: "+AuthUtils.isTokenExpired(this.token));
        console.log("is authenticated: "+(this.user!=null && this.token!=null && !AuthUtils.isTokenExpired(this.token)))*/
        return this.user!=null && this.token!=null && !AuthUtils.isTokenExpired(this.token);
    }
}
